import { render } from "./IndividualUser.vue?vue&type=template&id=ac9d3cb2&scoped=true"
import script from "./IndividualUser.vue?vue&type=script&lang=js"
export * from "./IndividualUser.vue?vue&type=script&lang=js"

import "./IndividualUser.vue?vue&type=style&index=0&id=ac9d3cb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9d3cb2"]])

export default __exports__